export default {
    API_DATE_FORMAT: 'YYYY-MM-DD',
    DISPLAY_DATE_FORMAT: 'DD/MM/YYYY',
    API_TIME_FORMAT: "HH:mm",

    MONDAY: "monday",
    TUESDAY: "tuesday",
    WEDNESDAY: "wednesday",
    THURSDAY: "thursday",
    FRIDAY: "friday",
    SATURDAY: "saturday",
    SUNDAY: "sunday",

    MOMENT_LOCALE: 'en',
    LOCALE: {
        "lang": {
            "placeholder": "Select date",
            "rangePlaceholder": [
                "Start date",
                "End date"
            ],
            "today": "Today",
            "now": "Now",
            "backToToday": "Back to today",
            "ok": "Ok",
            "clear": "Clear",
            "month": "Month",
            "year": "Year",
            "timeSelect": "Select time",
            "dateSelect": "Select date",
            "monthSelect": "Choose a month",
            "yearSelect": "Choose a year",
            "decadeSelect": "Choose a decade",
            "yearFormat": "YYYY",
            "dateFormat": "M/D/YYYY",
            "dayFormat": "D",
            "dateTimeFormat": "M/D/YYYY HH:mm:ss",
            "monthFormat": "MMMM",
            "monthBeforeYear": true,
            "previousMonth": "Previous month (PageUp)",
            "nextMonth": "Next month (PageDown)",
            "previousYear": "Last year (Control + left)",
            "nextYear": "Next year (Control + right)",
            "previousDecade": "Last decade",
            "nextDecade": "Next decade",
            "previousCentury": "Last century",
            "nextCentury": "Next century"
        },
        "timePickerLocale": {
            "placeholder": "Select time"
        }
    },
}
